import React from "react";

function NavBar() {
  return (
    <>
      <nav className="flex items-center justify-between mt-4 pt-6 px-5 lg:px-10 bg-almostWhite">
        <a href="/" className="flex items-center font-semibold">
          <img
            src="/aura_logo.png"
            className="h-12 w-12 lg:h-14 lg:w-14"
            alt="Auralocal Logo"
          />
          <span className="font-semibold text-2xl lg:text-3xl text-earth">
            auralocal
          </span>
        </a>
        <div className="flex items-center">
          <button className="font-medium text-lg text-earth hover:underline hover:text-lavender">
            <a
              href="https://www.marketlocal.ch/"
              alt="MarketLocal.ch le blog du marketing local en Suisse Romande."
            >
              Ressources gratuites
            </a>
          </button>
        </div>
      </nav>
    </>
  );
}

export default NavBar;